import React, { useState, lazy, Suspense, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import EcoProButton from "../../../../components/shared/button/button";
import {ReactComponent as PlusIcon} from "../../../../assets/images/mydevices/adddevice-plusIcon.svg";
import PrinterIcon from "../../../../assets/images/mydevices/addDevice-printerIcon.svg";
import BlockHeader from "../BlockHeader/BlockHeader";
import { Modal, ModalHeader } from "reactstrap";
import Loader from "../../../../components/shared/loader/Loader";
import { SOURCE_MY_DEVICE } from "../SuppliesComponent";
import { ReactComponent as ModalCloseIcon} from "../../../../assets/images/mydevices/modal-close-icon.svg";
import { useDispatch } from "react-redux";
import { ResetAPIsData, ResetCodeSubmissionState, ResetOneTimeCodeError } from "../../../../actions/Web/Customer/SignUp";
import { EnrollmentRegisterServiceReset } from "../../../../store/brotherPlus/EnrollmentService/RegisterService/RegisterServiceSlice";
import { removeLocalSessionData } from "../../../../utils/Authentication/handleUserSession";
import { LOCALSESSIONDATAKEYS } from "../../../../constants/AppConstants";
import { updateEnrolledDeviceReset } from "../../../../store/UserEnrolledDeviceDetails/UpdateUserEnrolledDeviceDetailsSlice";
import { routePath } from "../../../../constants/Routes";

const DeviceSearchComponent = lazy(() => import('./SearchDevice'));
const DeviceConfigComponent = lazy(() => import('./DeviceConfig'));
const connectDevicecomponent = lazy(() => import('../../../Web/Customer/Account/SignUp/Dashboard/ConnectDeviceDashboard'));


const AddDevice = () => {
    const { t } = useTranslation(["translation"]);
    const dispatch = useDispatch();
    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    const [isDeviceSubmitted, setIsDeviceSubmitted] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [addDeviceClicked, setaddDeviceClicked] = useState(false);
    const [selectedDeviceModel, setSelectedDeviceModel] = useState(null);
    const history = useHistory();

    const modalSteps = [
        {
            id: 'search-device', 
            component: DeviceSearchComponent,
            props: {
                setSelectedDeviceModel: setSelectedDeviceModel
            }
        },
        {
            id: 'connect-device', 
            component: connectDevicecomponent,
            props: {
                source: SOURCE_MY_DEVICE,
                addDevice_deviceModel: selectedDeviceModel,
                setIsDeviceSubmitted: setIsDeviceSubmitted
            }
        },
        {
            id: 'update-device-name-', 
            component: DeviceConfigComponent
        },
    ]

    const CurrentComponent = modalSteps[currentStepIndex].component;
    const CurrentComponentProps = modalSteps[currentStepIndex].props;

    const toggleModal = () => {
        setModalIsOpen(!modalIsOpen);
        setaddDeviceClicked(false);
        removeLocalSessionData(LOCALSESSIONDATAKEYS.ADD_NEW_DEVICES);
        dispatch(EnrollmentRegisterServiceReset());
        if(currentStepIndex === 2)
            history.push(routePath.MY_DEVICES);
    };

    const handleAddDeviceClick = () => {
        setaddDeviceClicked(true);
        setModalIsOpen(true);
        setCurrentStepIndex(0);
        setSelectedDeviceModel(null);
        removeLocalSessionData(LOCALSESSIONDATAKEYS.ADD_NEW_DEVICES);
        dispatch(ResetCodeSubmissionState());
        dispatch(ResetOneTimeCodeError());
        dispatch(ResetAPIsData());
        dispatch(EnrollmentRegisterServiceReset());
        dispatch(updateEnrolledDeviceReset());
    };

    useEffect( () => {
        if(currentStepIndex === 2)
            setIsDeviceSubmitted(false);
    }, [currentStepIndex] )
    
    return (
        <>
            <div className="my-device-add-device-wrapper">
                {
                    (addDeviceClicked)
                    ?   <BlockHeader 
                            icon={ PrinterIcon }
                            iconTitle= "printer-icon"
                            iconAlt= "printer-icon"
                            title= {t("MY_DEVICES.ADD_DEVICE")}
                        />
                    :   <EcoProButton onBtnClick={handleAddDeviceClick} cname = "add-device-button-container">
                            <span className="add-device-text"> <PlusIcon/>{t("MY_DEVICES.ADD_DEVICE")}</span>
                        </EcoProButton>
                }
        
                <Modal isOpen={modalIsOpen} className="my-devices-add-device-modal-container" fullscreen>
                    <ModalHeader className={ isDeviceSubmitted ? 'hideBtn' : '' } close={<ModalCloseIcon onClick={() => toggleModal()}/>}></ModalHeader>
                        <div className="add-device-modal-content-wrapper">
                            <Suspense fallback={<Loader />}>
                                <CurrentComponent {...CurrentComponentProps} AddDeviceSetCurrentStepIndex ={setCurrentStepIndex} />
                            </Suspense>
                        </div>
                </Modal>
            </div>
        </>
    )
}

export default AddDevice;